// src/components/ClientMissionsCard.jsx
// Point d'entrée client vers « Mes missions ». N'apparaît QUE si le conseiller a partagé
// des missions actives (via la RPC sécurisée get_client_missions). Sinon : rien.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "../lib/supabaseClient";

export default function ClientMissionsCard() {
  const { t } = useTranslation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await supabase.rpc("get_client_missions");
        if (!alive) return;
        setCount((data || []).filter((m) => !["closed", "cancelled"].includes(m.status)).length);
      } catch {
        /* silencieux : pas de mission = pas de carte */
      }
    })();
    return () => { alive = false; };
  }, []);

  if (!count) return null;

  return (
    <Link
      to="/mes-missions"
      className="mb-6 flex items-center justify-between gap-4 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition hover:border-gray-300 hover:bg-gray-50"
    >
      <div className="flex items-center gap-4">
        <span className="text-3xl" aria-hidden>🗂️</span>
        <div>
          <div className="text-base font-semibold text-gray-950">{t("clientMissions.title")}</div>
          <p className="mt-1 text-sm text-gray-600">
            {t("clientMissions.active", { count })}
          </p>
        </div>
      </div>
      <span className="shrink-0 rounded-xl bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white">{t("clientMissions.view")} →</span>
    </Link>
  );
}
